import auth from './auth'
import userbets from './userbets'
import currencies from './currencies'
import bookmakerLists from './bookmakerLists'
import news from './news'

export default {
  auth,
  userbets,
  currencies,
  bookmakerLists,
  news
}



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/